import { useFormikContext } from "formik";
import { ScheduleTemplateFormValues } from "./scheduleFormHelpers";
import { ScheduleMilestonePlanRows } from "./ScheduleMilestonePlanRows";
import { toMilestoneRowErrors } from "./scheduleMilestoneFormErrors";
import { dropStaleMilestoneExampleDates } from "./scheduleMilestonePreviewHelpers";
import styles from "./ScheduleDrawer.module.scss";

/** The policy form's milestone plan: Formik state in, sentence rows out. */
export const ScheduleMilestonePlanEditor: React.FC = () => {
    const { values, errors, submitCount, setFieldValue } =
        useFormikContext<ScheduleTemplateFormValues>();
    const isShowingErrors = submitCount > 0;
    const planError =
        isShowingErrors && typeof errors.milestones === "string"
            ? errors.milestones
            : null;
    const rowErrors = isShowingErrors
        ? toMilestoneRowErrors(errors.milestones)
        : undefined;

    return (
        <div className={styles.milestoneBlock}>
            {planError && <p className={styles.fieldError}>{planError}</p>}
            <ScheduleMilestonePlanRows
                milestones={values.milestones}
                errors={rowErrors}
                onChange={(milestones) => {
                    setFieldValue("milestones", milestones);
                    setFieldValue(
                        "milestoneExampleDates",
                        dropStaleMilestoneExampleDates({
                            previousMilestones: values.milestones,
                            milestones,
                            exampleDates: values.milestoneExampleDates,
                        }),
                    );
                }}
            />
        </div>
    );
};
